//import React from 'react'

import PropTypes from "prop-types";
import { useEffect } from "react";


const SelectCountry = ({ myCountry, setMyCountry, permisosMonitor }) => {
  useEffect(() => {
    if (permisosMonitor) {
      if(myCountry === ''){
        setMyCountry(permisosMonitor[0]);
      }
      
    }
  }, []);
  return (
    <div className="p-2">
      <label className="form-label" htmlFor="country">
        País:
      </label>
      <select
        className="form-control"
        name="country"
        value={myCountry}
        onChange={(e) => setMyCountry(e.target.value)}
      >
        {permisosMonitor?.length === 4 &&
        <option value="TD">TODOS</option>
        }
        {permisosMonitor?.includes('MX') &&
        <option value="MX">México</option>
        }
        {permisosMonitor?.includes('CO') &&
        <option value="CO">Colombia</option>
        }
        {permisosMonitor?.includes('PE') &&
        <option value="PE">Perú</option>
        }
        {permisosMonitor?.includes('CH') &&
        <option value="CH">Chile</option>
        }
        
      </select>
    </div>
  );
};

SelectCountry.propTypes = {
  myCountry: PropTypes.string.isRequired,
  setMyCountry: PropTypes.func,
};

export default SelectCountry;
